// extracted by mini-css-extract-plugin
export default {"root":"_3WNhcVk5","ordersButton":"_1PO_Iz8V","single":"co0Yp5Kc"};